import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=038d5b4e"
import script from "./Accident.vue?vue&type=script&lang=ts"
export * from "./Accident.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports